import moment from 'moment-timezone';
import { UserDate } from '@shared/services/userDate.service';

export const API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const ACCOUNT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const ANALYSIS_WINDOW_DATETIME_FORMAT = 'DD MMM YYYY HH:mm:ss';

function parseApiUtcDateTime(value) {
  if (moment.isMoment(value)) return value.clone();
  if (value instanceof Date || typeof value === 'number') return moment(value);

  const stringValue = String(value);
  const hasExplicitTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(stringValue);
  return hasExplicitTimezone
    ? moment.parseZone(stringValue)
    : moment.utc(stringValue);
}

export function resolveAccountTimezone(source) {
  const user =
    (source && source.state && source.state.user && source.state.user.data) ||
    (source && source.user && source.user.data) ||
    source ||
    {};
  return user.timezone || UserDate.userTimezone || 'UTC';
}

export function pickerDateTimeInAccountTimezone(value, timezone) {
  if (!value) return null;
  return moment.tz(
    moment(value).format(API_DATETIME_FORMAT),
    API_DATETIME_FORMAT,
    timezone
  );
}

export function formatAccountDateTime(
  value,
  timezone,
  format = ACCOUNT_DATETIME_FORMAT,
  emptyValue = '—'
) {
  if (!value) return emptyValue;
  const dateTime = parseApiUtcDateTime(value).tz(timezone);
  return dateTime.isValid() ? dateTime.format(format) : emptyValue;
}

export function formatAccountDate(value, timezone, emptyValue = '—') {
  return formatAccountDateTime(value, timezone, 'DD MMM YYYY', emptyValue);
}

export function formatAccountTime(value, timezone, emptyValue = '—') {
  return formatAccountDateTime(value, timezone, 'HH:mm:ss', emptyValue);
}

export function formatAnalysisWindow(
  startValue,
  endValue,
  timezone,
  emptyValue = 'Analysis window unavailable'
) {
  if (!startValue || !endValue) return emptyValue;
  const start = formatAccountDateTime(
    startValue,
    timezone,
    ANALYSIS_WINDOW_DATETIME_FORMAT,
    ''
  );
  const end = formatAccountDateTime(
    endValue,
    timezone,
    ANALYSIS_WINDOW_DATETIME_FORMAT,
    ''
  );
  return start && end ? `${start} – ${end}` : emptyValue;
}

export function accountDateToUtc(value, inputFormat, timezone, endOfDay = false) {
  if (!value) return null;
  const accountDate = moment.tz(value, inputFormat, timezone);
  if (endOfDay) accountDate.endOf('day');
  return accountDate.utc().format(API_DATETIME_FORMAT);
}

export function createPreviousAccountDayWindow(timezone) {
  const previousDay = moment.tz(timezone).subtract(1, 'day');
  return {
    start: moment(
      previousDay.clone().startOf('day').format(API_DATETIME_FORMAT),
      API_DATETIME_FORMAT
    ),
    end: moment(
      previousDay.clone().endOf('day').format(API_DATETIME_FORMAT),
      API_DATETIME_FORMAT
    )
  };
}
